import VenueCategoryIndex from './VenueCategoryIndex';
import VenueCategoryCreate from './VenueCategoryCreate';
import VenueCategorySettings from './VenueCategorySettings';
import VenueCategorySingle from './VenueCategorySingle';

export default function (app) {

    const settings = VenueCategorySettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 9,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    VenueCategoryIndex(app, settings);

    VenueCategoryCreate(app, settings);

    VenueCategorySingle(app, settings);

}